export default [
  {
    path: '/liveStream',
    name: 'liveStream',
    component: () => import('@/views/liveStream/index.vue'),
    meta: { title: '直播中心', pageLevel: 2 }
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('@/views/liveStream/live.vue'),
    meta: { title: '直播详情页', pageLevel: 3 }
  },
  {
    path: '/live/auth',
    name: 'liveAuth',
    component: () => import('@/views/liveStream/live.vue'),
    meta: { title: '直播授权页', pageLevel: 3 }
  },
  {
    path: '/liveStreamTrans',
    name: 'liveStreamTrans',
    component: () => import('@/views/liveStream/liveStreamTrans.vue'),
    meta: { title: '直播详情页' }
  }
]
